import { Injectable } from '@angular/core';
import { KeyValueStorage } from '@ionic-enterprise/secure-storage/dist/ngx';
import { Platform } from '@ionic/angular';
import { waitForCondition } from 'src/app/utilities/wait-for';

@Injectable()
export class StorageService {
  storageIsInitialized = false;
  private storage: KeyValueStorage;

  constructor(private platform: Platform) {}

  async create(encryptionKey: string) {
    if (this.storage) {
      return;
    }

    await this.platform.ready();
    this.storage = new KeyValueStorage();
    await this.storage.create(encryptionKey);
    this.storageIsInitialized = true;
    return;
  }

  async get<T = any>(key: string): Promise<T | null> {
    await this.waitUntilStorageIsInitialized();
    return await this.storage.get(key);
  }

  async set(key: string, value: any): Promise<any> {
    await this.waitUntilStorageIsInitialized();
    return await this.storage.set(key, value);
  }

  async remove(key: string): Promise<any> {
    await this.waitUntilStorageIsInitialized();
    return await this.storage.remove(key);
  }

  private async waitUntilStorageIsInitialized() {
    await waitForCondition(() => this.storage !== null && this.storageIsInitialized, true, 10);
  }
}
